__turbopack_context__.v({
  "courseSettingsBtn": "index-module__XkN13q__courseSettingsBtn",
  "courseSettingsBtnOpened": "index-module__XkN13q__courseSettingsBtnOpened",
  "coursesGrid": "index-module__XkN13q__coursesGrid",
  "thinScrollbar": "index-module__XkN13q__thinScrollbar",
});
